// extracted by mini-css-extract-plugin
module.exports = {"sizesAccordion":"SizesAccordion_sizesAccordion__Kv3Bd","sizeDisclaimer":"SizesAccordion_sizeDisclaimer__E46Yx"};